import { COMPANION_SINGLES } from './companions.js';
import { SCARECROW } from './scarecrow.js';
import { AURORA } from './aurora.js';
import { DRAGONSLAYER } from './dragonslayer.js';
import { DJINN } from './djinn.js';
import { SHAMAN } from './shaman.js';
/**
 * The shop's packs and pieces added since the founder and dragon sets
 * (ADR 0031): one file per pack or per family of singles, each exporting its
 * raw item templates and its raw offers, checked by the item and offer
 * schemas where `items.ts` and `shop.ts` gather them. A new pack is a file
 * here, a line below, its id in `SHOP_PACKS` and, when it gives one, its
 * title in `shop-titles.ts`.
 */
import { PACK_TRAIL_FILE, withPackTrail } from './pack-trails.js';
import { WINGS_WEAPONS } from './wings-weapons.js';
import { BOGWITCH_FILE } from './bogwitch.js';
import { SYLVAN_FILE } from './sylvan.js';
const FILES = [
    COMPANION_SINGLES,
    WINGS_WEAPONS,
    SCARECROW,
    AURORA,
    DRAGONSLAYER,
    SYLVAN_FILE,
    BOGWITCH_FILE,
    DJINN,
    SHAMAN,
    PACK_TRAIL_FILE,
];
export const COSMETIC_TEMPLATES = FILES.flatMap((file) => file.templates);
// Each pack's bundle also carries its trail (`pack-trails.ts`).
export const COSMETIC_OFFERS = FILES.flatMap((file) => file.offers).map(withPackTrail);
//# sourceMappingURL=index.js.map